const shortcutsPromise = import(/* webpackChunkName: 'shortcutsBundle' */ '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/shortcuts/shortcuts.js?vue3')
  .then(({ default: Shortcuts }) => new Shortcuts())
  // Fall back to a no-op instance when the chunk fails to load so callers
  // never crash on `undefined` (shortcuts are optional).
  .catch(() => ({ addExtension: () => {}, extensions: new Map() }));

export const addShortcutsExtension = (ShortcutExtension, ...args) =>
  shortcutsPromise.then((shortcuts) => shortcuts.addExtension(ShortcutExtension, args));

export { markShortcutExtensionReady } from './shortcuts_ready_marker';

export const resetShortcutsForTests = async () => {
  if (process.env.NODE_ENV === 'test') {
    const { Mousetrap, clearStopCallbacksForTests } = await import('~/lib/mousetrap');
    clearStopCallbacksForTests();
    Mousetrap.reset();
    const shortcuts = await shortcutsPromise;
    shortcuts.extensions.clear();
    delete document.body.dataset.shortcutsReady;
  }
};
